import { DetailedActualizationParams } from 'sletat-api-services/lib/module/tourActualization/detailedActualization/request';
import { DetailedActualizationAsyncService } from 'sletat-api-services/lib/module/tourActualization/detailedActualization/detailedActualizationAsyncService';
import { ActualizePriceResponse } from 'sletat-api-services/lib/module/tourActualization/response';

import { MODULE_HOST_NAME } from '../../consts/hosts';
import { hotelPageLogger } from '../../utils/logger';
import { ActualizationStatus } from '../models/actualization';
import { ActualizationInfo } from './primary-actualization';
import { extractActualizationData } from '../utils/actualization';


export { ActualizePriceResponse };


export interface DetailedActualizationService {
    getPromise: () => Promise<ActualizationInfo>;
    cancel: () => void;
}

export function detailedActualizationService(params: DetailedActualizationParams, tourId: string): DetailedActualizationService {
    const service = new DetailedActualizationAsyncService({ host: MODULE_HOST_NAME });
    const promise = new Promise<ActualizationInfo>((resolve, reject) => {
        service.once('success', (resp: ActualizePriceResponse) => {
            if (!!resp.errorMessage) {
                hotelPageLogger.warn(`${tourId} detailedActualization failed: `, resp.errorMessage);
                resolve({ status: ActualizationStatus.Failed });
                return;
            }
            resolve({
                status: ActualizationStatus.Success,
                data: extractActualizationData(resp)
            });
        });

        service.once('failed', err => {
            hotelPageLogger.warn(`${tourId} detailedActualization failed: `, err);
            resolve({ status: ActualizationStatus.Failed });
        });

        service.once('cancelled', reject);
        service.start(params);
    });


    return {
        getPromise: () => promise,
        cancel: () => service.cancel()
    };
}
